import type { AppointmentType } from '@/features/appointments/utils/AppointmentType';
import useAppointmentStore from '@/store/AppointmentStore';

type OrchestrateAppointmentFlow = (type: AppointmentType) => void;

const useOrchestrateAppointmentFlow = (): OrchestrateAppointmentFlow => {
  const setSelectedAppointmentType = useAppointmentStore(
    (s) => s.setSelectedAppointmentType,
  );
  const setContactInfo = useAppointmentStore((s) => s.setContactInfo);
  const contactInfo = useAppointmentStore((s) => s.contactInfo);

  return (type: AppointmentType) => {
    setSelectedAppointmentType(type);
    if (type === 'in-branch') {
      setContactInfo({ ...contactInfo, communicationPreference: 'In Person' });
    } else if (type === 'online') {
      setContactInfo({ ...contactInfo, communicationPreference: undefined });
    }
  };
};

export default useOrchestrateAppointmentFlow;
